import { ReactChild, useState, useEffect } from 'react';
import type { MenuProps } from 'antd';
import { Menu } from 'antd';
import { Link } from "react-router-dom";

import { menus } from "./../../router/menu";
import store from './../../store';
import "./index.scss";

import logoImg from "./../../assets/img/logo.jpg";
import { checkPrivilege } from '../../utils';

interface MenuItemProps {
  children?: Array<MenuItemProps>,
  name: string,
  icon?: ReactChild,
  path: string,
  title: string
}

type MenuItem = Required<MenuProps>['items'][number];

function getItem(
  label: React.ReactNode,
  key: React.Key,
  icon?: React.ReactNode,
  children?: MenuItem[],
  type?: 'group',
): MenuItem {
  return {
    key,
    icon,
    children,
    label,
    type,
  } as MenuItem;
}

// 递归过滤菜单项
const filterMenus = (menus: any) => {
  return menus
    .filter((menu: any) => checkPrivilege(menu?.privilegeCode) || menu?.privilegeCode === '' ) // 过滤掉不满足条件的菜单项
    .map((menu: any) => ({
      ...menu,
      children: menu.children ? filterMenus(menu.children) : [] // 递归过滤子菜单
    }))
};
const filteredMenus = filterMenus(menus);

const renderMenuItem = (menu: MenuItemProps): MenuItem => {
  const children = menu.children?.length
    ? menu.children.map((child: MenuItemProps) => renderMenuItem(child))
    : undefined;

  const label = children ? (
    <span>{menu.title}</span>
  ) : (
    <Link to={menu.path}>
      <span>{menu.title}</span>
    </Link>
  );

  return getItem(label, menu.name, menu.icon, children);
}

const items: (MenuItem[] | any) = filteredMenus?.map((menu: MenuItemProps) => renderMenuItem(menu));

export const Sider = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [selectedKeys, setSelectedKeys] = useState<string[]>([]);
  const [openKeys, setOpenKeys] = useState<string[]>([]);

  const getStore = () => {
    store.subscribe(() => {
      setCollapsed(store.getState().common.siderCollapsed)
    });
  }

  const onSelect = (e: any) => {
    setSelectedKeys(e.selectedKeys);
  }

  const onOpenChange = (openKeys: string[]) => {
    setOpenKeys(openKeys);
  }

  useEffect(() => {
    const matchKeys: string[] = window.location.pathname.split('/').filter(Boolean);
    setSelectedKeys([matchKeys[matchKeys.length - 1]]);
    setOpenKeys(matchKeys);
  }, []);

  useEffect(() => {
    getStore();
  }, [collapsed]);

  return (
    <div className={collapsed ? "menuContent collapsed" : "menuContent"} >
      <span className={collapsed ? 'collapsed logo' : 'logo'}>
        <img className='logoImg' src={logoImg} alt="" />
      </span>
      <Menu
        mode="inline"
        theme="dark"
        inlineCollapsed={collapsed}
        items={items}
        onSelect={onSelect}
        selectedKeys={selectedKeys}
        onOpenChange={onOpenChange}
        openKeys={openKeys}
      />
    </div>
  );
}
